import requestApi from "../common/boxp_api_client";
import { BASE_API_URL_BOXP } from "lib/constants";
const getWorkshopOrderListing = (params) => {
    return requestApi({
        url: `/account_maintenance_list`,
        method: "GET",
        params: params
    });
};

const getWorkshopInvoice = (params) => {
    return requestApi({
        url: `/invoice`,
        method: "GET",
        params: params
    });
};
const getCustomerList = (params) => {
    return requestApi({
        url: `${BASE_API_URL_BOXP}/customers-list`,
        method: "GET",
        params
    });
};

const createInvoice = (data) => {
    return requestApi({
        url: `/invoice`,
        method: "POST",
        data,
    });
};
const updateInvoice = (data, id) => {
    return requestApi({
        url: `/invoice/${id}?_method=PUT`,
        method: "POST",
        data,
    });
}; const deleteInvoice = (data, id) => {
    return requestApi({
        url: `/delete_invoice?_method=PUT`,
        method: "POST",
        data,
    });
};
const updatePaymentDetails = (data, id) => {
    return requestApi({
        url: `/invoice_toggle?_method=PUT`,
        method: "POST",
        data,
    });
};
const getStorageCharges = (params) => {
    return requestApi({
        url: `/storage_charges`,
        method: "GET",
        params: params

    });
};
const getWorkshopOrderListingCSV = (params) => {
    return requestApi({
        url: `/account_maintenance_list`,
        method: "GET",
        params: params
    });
};

const downloadFiles = (params) => {
    return requestApi({
        url: `/download_file`,
        method: "GET",
        params: params
    });
}
const getStandardPricing = (params) => {
    return requestApi({
        url: `/standard_pricing`,
        method: "GET",
        params: params
    });
};
const createStandardPricing = (data) => {
    return requestApi({
        url: `/standard_pricing`,
        method: "POST",
        data,
    });
};
const updateEscalatesPricing = (data, id) => {
    return requestApi({
        url: `/escalate_pricing?_method=PUT`,
        method: "POST",
        data
    });
}; const updateStandardPricing = (data, id) => {
    return requestApi({
        url: `/standard_pricing/${id}?_method=PUT`,
        method: "POST",
        data
    });
};
const updateArchiveState = (data, id) => {
    return requestApi({
        url: `/archive_unarchive?_method=PUT`,
        method: "POST",
        data
    });
};
const getHistoricalAverages = (params) => {
    return requestApi({
        url: `/historical_averages`,
        method: "GET",
        params: params
    });
}; const getHistoricalOrders = (params) => {
    return requestApi({
        url: `/historical_orders`,
        method: "GET",
        params: params
    });
}; const getOverviewDetails = (params) => {
    return requestApi({
        url: `/overview_section`,
        method: "GET",
        params: params
    });
};
const WorkshopReportService = {
    getWorkshopOrderListing,
    getWorkshopInvoice,
    getCustomerList,
    createInvoice,
    updateInvoice,
    getStorageCharges,
    getWorkshopOrderListingCSV,
    downloadFiles,
    getStandardPricing,
    createStandardPricing,
    updateEscalatesPricing,
    updateArchiveState,
    getHistoricalAverages,
    getHistoricalOrders,
    updateStandardPricing,
    updatePaymentDetails,
    getOverviewDetails,
    deleteInvoice
};

export default WorkshopReportService;